<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">Franchise Fees Paid</h3>
    </b-card-header>
    <b-card-body>
      <div class="chart">
        <pie-chart
          id="pie-chart"
          :height="350"
          :chart-data="pieChart.chartData"
          :extra-options="pieChart.extraOptions"
        >
        </pie-chart>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import PieChart from '@/components/Charts/PieChart';
import * as chartConfigs from '@/components/Charts/config';
import { Charts } from '@/components/Charts/config';
import {Select, Option} from 'element-ui';

export default {
  mixins: [errorsMixin],
  components: {
    PieChart,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    userRoute: null,
    year: null,
  },
  data() {
    return {
      pieChart: {
        chartData: {
          labels: [
            'Franchise Fees',
            'Royalties Paid'
          ],
          datasets: [{
            data: [],
            backgroundColor: [
              Charts.colors.theme['danger'],
              Charts.colors.theme['success'],
            ],
            label: 'Dataset 1'
          }],
        },
        extraOptions: {
          responsive: true,
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 25,
              fontSize: 15,
              generateLabels: (chart) => {
                const datasets = chart.data.datasets;
                return datasets[0].data.map((data, i) => ({
                  text: `${chart.data.labels[i]}: ${this.$options.filters.currency(data)}`,
                  fillStyle: datasets[0].backgroundColor[i],
                  index: i
                }))
              }
            }
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var dataLabel = data.labels[tooltipItem.index];
                var value = ': $' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString();

                if (Chart.helpers.isArray(dataLabel)) {
                  dataLabel = dataLabel.slice();
                  dataLabel[0] += value;
                } else {
                  dataLabel += value;
                }

                return dataLabel;
              }
            }
          },
        }
      },
    }
  },
  computed: {
    royaltyPercent() {
      if (this.pieChart.chartData.datasets[0].data.length > 0) {
        let royaltyPercent = this.pieChart.chartData.datasets[0].data[1] / this.pieChart.chartData.datasets[0].data[0] * 100;
        return royaltyPercent < 100 ? royaltyPercent : 100;
      } else {
        return 0;
      }
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/reports/royalties-chart?year=" + this.year)
        .then(response => {
          this.pieChart.chartData = {
            labels: [
              'Franchise Fees',
              'Franchise Fees Paid'
            ],
            datasets: [{
              data: response.data,
              backgroundColor: [
                Charts.colors.theme['danger'],
                Charts.colors.theme['success'],
              ],
              label: 'Dataset 1'
            }],
          }
        })
        .catch(error => {
          this.error(error);
        });
    }
  },
  created() {
    this.getItems();
  }
};
</script>